import * as yup from 'yup';

export const createFormSchemasPJ = (t) => {
  const senhaRegex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()+_\-.,?":{}|<>])[A-Za-z\d!@#$%^&*()+_\-.,?":{}|<>]{8,15}$/;
  const cnpjRegex = /^(?:[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}|[A-Z0-9]{12}\d{2})$/;

  const hasBrazilianMobileFormat = (value) => {
    if (!value) return true;
    const digits = value.replace(/\D/g, '');
    return /^9\d{8}$/.test(digits);
  };

  const formSchemaPJ = yup.object().shape({
    cnpj: yup
      .string()
      .transform((value) => (value ? value.trim().toUpperCase() : value))
      .typeError(t('cadastro.messages.validation.cnpj_required'))
      .required(t('cadastro.messages.validation.cnpj_required'))
      .matches(cnpjRegex, t('cadastro.messages.validation.cnpj_required')),
    nome: yup
      .string()
      .typeError(t('cadastro.messages.validation.company_name_required'))
      .required(t('cadastro.messages.validation.company_name_required')),
    nomeFantasia: yup
      .string()
      //    .typeError('Favor informar o nome fantasia.')
      //    .required('Favor informar o nome fantasia.')
      .max(100, t('cadastro.messages.validation.trade_name_max_length')),
    cpf: yup
      .string()
      .typeError(t('cadastro.messages.validation.invalid_cpf'))
      .required(t('cadastro.messages.validation.cpf_required')),
    dataNascimento: yup
      .date()
      .typeError(t('cadastro.messages.validation.birth_date_required'))
      .required(t('cadastro.messages.validation.birth_date_required'))
      .max(new Date(), t('cadastro.messages.validation.birth_date_future')),
    dddMovel: yup
      .string()
      .typeError(t('cadastro.messages.validation.ddd_required'))
      .required(t('cadastro.messages.validation.ddd_required')),
    foneMovel: yup
      .string()
      .typeError(t('cadastro.messages.validation.phone_required'))
      .required(t('cadastro.messages.validation.phone_required'))
      .test(
        'fone-movel-pj-nacional',
        t('cadastro.messages.validation.brazilian_mobile_format'),
        function (value) {
          if (!value) return true;
          if (this.parent.ddiMovel && this.parent.ddiMovel !== '55') {
            return true;
          }
          return hasBrazilianMobileFormat(value);
        },
      ),
    email: yup
      .string()
      .typeError(t('cadastro.messages.validation.email_required'))
      .required(t('cadastro.messages.validation.email_required'))
      .email(t('cadastro.messages.validation.invalid_email')),
    senha: yup
      .string()
      .typeError(t('cadastro.messages.validation.password_required'))
      .required(t('cadastro.messages.validation.password_required'))
      .test(
        'no-slashes',
        t('cadastro.messages.validation.password_no_slashes'),
        (value) => {
          if (!value) return true;
          return !value.includes('/') && !value.includes('\\');
        },
      )
      .matches(senhaRegex, t('cadastro.messages.validation.password_match')),
    confirmaSenha: yup
      .string()
      .typeError(t('cadastro.messages.validation.confirm_password_required'))
      .required(t('cadastro.messages.validation.confirm_password_required'))
      .oneOf(
        [yup.ref('senha'), null],
        t('cadastro.messages.validation.passwords_must_match'),
      ),
  });

  const formSchemaPJAN8 = yup.object().shape({
    an8: yup
      .string()
      .typeError(t('cadastro.messages.validation.an8_required'))
      .required(t('cadastro.messages.validation.an8_required'))
      .max(8, t('cadastro.messages.validation.an8_length'))
      .matches(/^\d+$/, t('cadastro.messages.validation.numeric_only')),
    numeroContrato: yup
      .string()
      .typeError(t('cadastro.messages.validation.contract_required'))
      .required(t('cadastro.messages.validation.contract_required'))
      .max(10, t('cadastro.messages.validation.contract_max_length'))
      .matches(/^\d+$/, t('cadastro.messages.validation.numeric_only')),
    nome: yup
      .string()
      .typeError(t('cadastro.messages.validation.company_name_required'))
      .required(t('cadastro.messages.validation.company_name_required')),
    nomeFantasia: yup
      .string()
      //    .typeError('Favor informar o nome fantasia.')
      //    .required('Favor informar o nome fantasia.')
      .max(100, t('cadastro.messages.validation.trade_name_max_length')),
    dddMovel: yup
      .string()
      .typeError(t('cadastro.messages.validation.ddd_required'))
      .required(t('cadastro.messages.validation.ddd_required')),
    foneMovel: yup
      .string()
      .typeError(t('cadastro.messages.validation.phone_required'))
      .required(t('cadastro.messages.validation.phone_required'))
      .test(
        'fone-movel-pj-an8',
        t('cadastro.messages.validation.brazilian_mobile_format'),
        function (value) {
          if (!value) return true;
          if (this.parent.ddiMovel !== '55') return true;
          return hasBrazilianMobileFormat(value);
        },
      ),
    email: yup
      .string()
      .typeError(t('cadastro.messages.validation.email_required'))
      .required(t('cadastro.messages.validation.email_required'))
      .email(t('cadastro.messages.validation.invalid_email')),
    senha: yup
      .string()
      .typeError(t('cadastro.messages.validation.password_required'))
      .required(t('cadastro.messages.validation.password_required'))
      .test(
        'no-slashes',
        t('cadastro.messages.validation.password_no_slashes'),
        (value) => {
          if (!value) return true;
          return !value.includes('/') && !value.includes('\\');
        },
      )
      .matches(senhaRegex, t('cadastro.messages.validation.password_match')),
    confirmaSenha: yup
      .string()
      .typeError(t('cadastro.messages.validation.confirm_password_required'))
      .required(t('cadastro.messages.validation.confirm_password_required'))
      .oneOf(
        [yup.ref('senha'), null],
        t('cadastro.messages.validation.passwords_must_match'),
      ),
    idcorreios: yup
      .string()
      .required(t('cadastro.messages.validation.user_required'))
      .min(10, t('cadastro.messages.validation.user_min_length_cadastro_sem_cpf'))
      .max(15, t('cadastro.messages.validation.user_max_length'))
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/,
        t('cadastro.messages.validation.user_must_have_letters_and_numbers'),
      ),
  });

  return {
    formSchemaPJ,
    formSchemaPJAN8,
  };
};

// Backward compatibility export for direct imports
export const formSchemaPJ = null;
export const formSchemaPJAN8 = null;
